import { render } from "./CreateNewGameModal.vue?vue&type=template&id=3e9de894&scoped=true"
import script from "./CreateNewGameModal.vue?vue&type=script&lang=js"
export * from "./CreateNewGameModal.vue?vue&type=script&lang=js"

import "./CreateNewGameModal.vue?vue&type=style&index=0&id=3e9de894&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9de894"]])

export default __exports__